import React, { useEffect, useState } from "react";
import ImgModal from "./ImgModal";

const Accordion = (props) => {
  const qna = props.qnaList;
  const faqIm = props.faqImList;
  const noticeList = props.noticeList;
  const noticeParamId = props.noticeId;
  const qnaImgUrl = qna !== undefined ? qna.images : null;

  const noticeContents = noticeList !== undefined ? noticeList.content : null;
  const noticeContent =
    noticeContents !== null ? noticeContents.split("\n") : "";
  const noticeId = noticeList !== undefined ? noticeList.id : null;

  //notice parameter 있을 시 해당 체크박스 체크
  useEffect(() => {
    if (noticeParamId !== undefined && noticeParamId !== null) {
      if (Number(noticeParamId) === Number(noticeId)) {
        const noticeCheck = document.getElementById(`notice${noticeParamId}`);
        noticeCheck.checked = true;
        noticeCheck.scrollTop = noticeCheck.scrollHeight;
      }
    }
  }, []);

  /**이미지 크게보기 */
  const [modalImg, setModalImg] = useState();
  const [imgModalOpen, setImgModalOpen] = useState(false);

  const modalOpen = (e) => {
    setModalImg(e.target.src);
    setImgModalOpen(true);
  };
  // 이미지 모달 있을 시 스크롤 고정
  useEffect(() => {
    if (imgModalOpen === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [imgModalOpen]);

  //문의 날짜 및 시간 - 한국시간 노출
  const [qnaDate, setQnaDate] = useState("");
  const qnaCreateDate = qna !== undefined ? qna.createdDate : null;
  const offset = 1000 * 60 * 60 * 9;
  const qnaFullDate = qnaCreateDate && qnaCreateDate.split("Z")[0];
  const koreaDate = new Date(new Date(qnaFullDate).getTime() + offset);

  function dateFormat(date) {
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();

    month = month >= 10 ? month : "0" + month;
    day = day >= 10 ? day : "0" + day;
    hour = hour >= 10 ? hour : "0" + hour;
    minute = minute >= 10 ? minute : "0" + minute;
    second = second >= 10 ? second : "0" + second;

    return (
      date.getFullYear() +
      "-" +
      month +
      "-" +
      day +
      " " +
      hour +
      ":" +
      minute +
      ":" +
      second
    );
  }
  useEffect(() => {
    const dateTrans = dateFormat(koreaDate);
    setQnaDate(dateTrans);
  }, [qnaDate]);

  return (
    <>
      {qna !== undefined && faqIm === undefined && noticeList === undefined ? (
        <div className="tab qna_accordion" >
          <input type="checkbox" id={`qna${qna.id}`} name="qna" />
          <label className="tab_label" htmlFor={`qna${qna.id}`}>
            <span className="tab_title">
              <span className="tab_deb1 category">[{qna.category}]</span>
              <span className="tab_deb1 title">{qna.question}</span>
              <span className="accordion_state tab_deb1">
                <span>{qnaDate}</span>
                <span className="gubun">|</span>
                <span>{qna.state === false ? "미응답" : "응답완료"}</span>
              </span>
            </span>
          </label>
          <div className="tab_content">
            <div className="question">
              <p className="question_txt">{qna.question}</p>
              <div className="question_img">
                {qnaImgUrl
                  ? qnaImgUrl &&
                  qnaImgUrl.map((img, index) => {
                    return (
                      <img src={img} alt="문의사진" onClick={modalOpen} key={`문의사진-${index}`} />
                    );
                  })
                  : null}
              </div>
            </div>
            {qna.state === true ? (
              <div className="answer">
                <h5>[답변 내용]</h5>
                <p dangerouslySetInnerHTML={{ __html: qna.answer }}></p>
              </div>
            ) : null}
          </div>
        </div>
      ) : qna === undefined &&
        faqIm !== undefined &&
        noticeList === undefined ? (
        <div className="tab faq_accordion">
          <input type="checkbox" id={faqIm.id} name="faq" />
          <label className="tab_label" htmlFor={faqIm.id}>
            <span>{faqIm.question}</span>
          </label>
          <div className="tab_content question">
            <p className="question_txt">{faqIm.question}</p>
            <div className="answer">
              <h5>[답변]</h5>
              <p>{faqIm.answer}</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="tab faq_accordion">
          <input type="checkbox" id={"notice" + noticeList.id} name="notice" />
          <label
            className="tab_label"
            htmlFor={"notice" + noticeList.id}
          >
            <span>{noticeList.title}</span>
          </label>
          <div className="tab_content question">
            <div className="answer">
              {noticeContent &&
                noticeContent.map((content) => {
                  return <p>{content}</p>;
                })}
            </div>
          </div>
        </div>
      )}
      {imgModalOpen && (
        <ImgModal
          closeModal={() => {
            setImgModalOpen(false);
          }}
        >
          <img className="modal_img" src={modalImg} alt="사진크게보기" />
        </ImgModal>
      )}
    </>
  );
};
export default Accordion;
